// extracted by mini-css-extract-plugin
export default {"container":"_ZLtKD","section":"_EgZRv","title":"_dyuGL","body":"_xHfV1","cta":"_D83rL"};